// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { getBillingSummary } from '@/billing/api/get-billing-summary';
import { TWO_MINUTES_MS } from '@/utilities/time-constants';
import { useSuspenseQuery } from '@tanstack/react-query';

export function useBillingSummary() {
  return useSuspenseQuery({
    queryKey: ['billing', 'summary'],
    queryFn: getBillingSummary,
    refetchOnWindowFocus: true,
    refetchInterval: TWO_MINUTES_MS,
  });
}
